import type { ReactNode } from 'react'

/**
 * Каркас: просто содержимое экрана — как в боте, где нет вкладок и нет
 * постоянного меню на экране. Переход домой/к цели/к помощи — свои кнопки
 * на каждом экране (Catalog.tsx, Progress.tsx, Help.tsx…), теми же подписями,
 * что и «🏠 Главное меню» у бота.
 *
 * Экран задачи держит свою «🏠» в ряду кнопок под лентой (Task.tsx). Прежде она
 * висела в углу экрана поверх всего и на короткой ленте садилась на кнопку
 * отправки: панель ввода прижата к низу только когда лента длиннее экрана.
 */
export default function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="app">
      <main className="app-main">{children}</main>
    </div>
  )
}
